import React from 'react';
import HomePage from './pages/HomePage';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return <HomePage />;
}

export default App;
